import { useState } from 'preact/hooks';
import { ApiError, login, type CurrentUser } from '../api';
import { Icon } from '../components/icons';

export function Login({ onLogin, adminConfigured }: { onLogin: (u: CurrentUser) => void; adminConfigured: boolean }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: Event) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onLogin(await login(username, password, remember));
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'No se pudo conectar con el servidor.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main class="login">
      <form class="login-card" onSubmit={submit} aria-labelledby="login-title">
        <div class="login-brand">
          <span class="brand-mark" aria-hidden="true">
            <Icon name="board" size={20} />
          </span>
          <div>
            <h1 id="login-title">Taller Eléctrico</h1>
            <p class="muted">REDMIL Power Builders</p>
          </div>
        </div>
        {!adminConfigured && (
          <p class="notice notice-error" role="alert">
            Falta configurar la contraseña inicial del administrador (ADMIN_PASSWORD).
          </p>
        )}
        <label class="field">
          <span>Usuario</span>
          <input autoComplete="username" autoCapitalize="none" spellcheck={false} value={username} onInput={(e) => setUsername(e.currentTarget.value)} required />
        </label>
        <label class="field">
          <span>Contraseña</span>
          <input type="password" autoComplete="current-password" value={password} onInput={(e) => setPassword(e.currentTarget.value)} required />
        </label>
        <label class="check">
          <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.currentTarget.checked)} />
          <span>Mantener la sesión en esta tablet (30 días)</span>
        </label>
        {error && (
          <p class="notice notice-error" role="alert">
            {error}
          </p>
        )}
        <button class="btn btn-primary" type="submit" disabled={busy}>
          {busy ? 'Entrando…' : 'Iniciar sesión'}
        </button>
        <p class="muted small">
          ¿Solo quiere ver una demostración? <a href="?demo=1">Abrir el modo demo</a>
        </p>
      </form>
    </main>
  );
}
